import React from 'react';
import PropTypes from 'prop-types';

const InputField = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  name,
  id,
  label,
  error,
  className = '',
  labelClassName = '',
  inputClassName = '',
  required = false,
  disabled = false,
  variant = 'default',
  ...props
}) => {
  const baseClasses = 'w-full px-4 py-2 border focus:outline-none focus:ring-2 transition-colors duration-200';
  
  const variants = {
    default: 'border-gray-300 focus:ring-blue-200 focus:border-blue-500',
    demo: 'h-11 px-3.5 py-2.5 bg-white border-[#e9eaec] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] text-[#6a7082] focus:ring-[#2a62aa]',
    feature: 'border-gray-300 focus:ring-[#2a62aa] focus:border-[#2a62aa]',
    privacy: 'border-gray-300 focus:ring-blue-200 focus:border-blue-500'
  };

  const errorClasses = error ? 'border-red-500 focus:ring-red-200' : '';
  const disabledClasses = disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white';
  const roundedClasses = variant === 'demo' ? 'rounded-lg' : 'rounded';
  
  const inputClasses = `
    ${baseClasses}
    ${variants[variant]}
    ${errorClasses}
    ${disabledClasses}
    ${roundedClasses}
    ${inputClassName}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label 
          htmlFor={id || name} 
          className={`block text-sm font-medium text-[#121725] mb-1 ${labelClassName}`}
        >
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          type={type}
          id={id || name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={inputClasses}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

InputField.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'demo', 'feature', 'privacy'])
};

export default InputField;